/** UI languages the app ships translations for. Mirrors the backend list. */
export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * Fallback used when nothing else resolves: the account has no language, the
 * browser reports something we do not translate, and there is no local
 * choice. Spanish, because the office this app serves runs in Spanish.
 */
export const DEFAULT_LANGUAGE: Language = 'es';

/** Key the chosen language is mirrored to, so a reload never flashes the wrong one. */
export const LANGUAGE_STORAGE_KEY = 'deskbooking.language';

/** Flat key -> text map. Keys are dotted for grouping only; lookups are exact. */
export type Catalog = Record<string, string>;

export const isSupportedLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);

/** BCP-47 tag used for Intl date / number formatting in each language. */
export const LOCALE_TAG: Record<Language, string> = {
  es: 'es-CR',
  en: 'en-US',
};

/** How each option is offered in the selector, in its own language. */
export const LANGUAGE_LABELS: Record<Language, { name: string; short: string }> = {
  es: { name: 'Español', short: 'ES' },
  en: { name: 'English', short: 'EN' },
};
